import type firebase from 'firebase/compat/app';
import type Stripe from 'stripe';

export const convertToAdminDetail: firebase.firestore.FirestoreDataConverter<IAdminDetail> =
  {
    fromFirestore: snapshot => snapshot.data() as IAdminDetail,
    toFirestore: (data: IAdminDetail) => data
  };

export const convertToMember: firebase.firestore.FirestoreDataConverter<IMember> =
  {
    fromFirestore: snapshot => snapshot.data() as IMember,
    toFirestore: (data: IMember) => data
  };

export const convertToPasswordHistory: firebase.firestore.FirestoreDataConverter<IPasswordHistory> =
  {
    fromFirestore: snapshot => snapshot.data() as IPasswordHistory,
    toFirestore: (data: IPasswordHistory) => data
  };

export const convertToTeam: firebase.firestore.FirestoreDataConverter<ITeam> = {
  fromFirestore: snapshot => snapshot.data() as ITeam,
  toFirestore: (data: ITeam) => data
};

export const convertToUser: firebase.firestore.FirestoreDataConverter<IUser> = {
  fromFirestore: snapshot => snapshot.data() as IUser,
  toFirestore: (data: IUser) => data
};

export function getQuantity(customer?: Stripe.Customer) {
  const subscription = customer?.subscriptions?.data?.find(
    sub => sub.status !== 'canceled'
  );
  const item = subscription?.items?.data?.find(it => it.price?.active);
  return item?.quantity;
}

export class NeedSignIn extends Error {
  constructor() {
    super('Need sign in');
  }
}
